/**
 * Resolving "our alliance" and "our state".
 *
 * Both are server-side configuration (spec section 6), so the frontend does not
 * hold a constant for either. The dashboard response is the authoritative
 * carrier, and every screen that needs the core alliance id derives it from
 * there rather than from a hardcoded value.
 */

import { useDashboard } from '../api/queries';

export type CoreContext = {
  allianceId: string | null;
  allianceLabel: string | null;
  kingdomId: number | null;
  isPending: boolean;
  error: unknown;
};

export function useCoreContext(): CoreContext {
  const dashboard = useDashboard();
  const core = dashboard.data?.coreAlliance ?? null;

  return {
    allianceId: core?.id ?? null,
    allianceLabel: core ? (core.abbr ?? core.name ?? core.id) : null,
    kingdomId: core?.kingdomId ?? null,
    isPending: dashboard.isPending,
    error: dashboard.error,
  };
}
